import type { TemplateProps } from '@ps-smart-cp/ppfw-client';
import { Template } from '@ps-smart-cp/ppfw-client';

export function TemplateWithoutJobTab({ children, ...restProps }: TemplateProps) {
  return (
    <Template hiddenTabs={['job']} {...restProps}>
      {children}
    </Template>
  );
}
